// fetchImageUrl.ts
import { api } from '@here/api'

// Supabase signs for 60m; keep data fresh for ~55m
const SIGNED_URL_SECONDS = 60 * 60
const STALE_TIME_MS = 55 * 60 * 1000

async function tryExt(id: string, ext: string): Promise<string | null> {
  const path = `${id}.${ext}`
  const { data, error } = await api()
    .storage.from('profile-images')
    .createSignedUrl(path, SIGNED_URL_SECONDS)

  return !error && data?.signedUrl ? data.signedUrl : null
}

export async function fetchImageUrl(id: string): Promise<string | null> {
  // Try jpg then png; return null if not found
  return (await tryExt(id, 'jpg')) ?? (await tryExt(id, 'png')) ?? null
}

// Query opts factory
export const avatarQueryOpts = (id?: string) => ({
  queryKey: ['avatarUrl', id],
  enabled: !!id,
  queryFn: () => fetchImageUrl(id!),          // will resolve to string | null
  staleTime: STALE_TIME_MS,
  gcTime: 2 * 60 * 60 * 1000,                 // keep in cache for 2h
  refetchOnWindowFocus: false,
  retry: 1,
  // Ensure Query never has undefined before first resolve
  placeholderData: null as string | null,
})
